module.exports = __webpack_public_path__ + "img/weather_08.254a5657.png";